import { useState } from "react";
import CustomCard from "../Card";
import GroupSignupForm from "./GroupSignupForm";
import SuccessSignup from "../SuccessSignUp";

function GroupSignup() {
  const [level, setLevel] = useState(1);
  return (
    <>
      {level !== 8 && (
        <CustomCard
          level={level}
          title={
            level === 1
              ? "ثبت نام گروه"
              : level === 2
                ? "وارد کردن کد تأیید"
                : level === 3
                  ? "اطلاعات شخصی مسئول گروه"
                  : level === 4
                    ? "اطلاعات عمومی گروه"
                    : level === 5
                      ? "تصویر گروه"
                      : level === 6
                        ? "اطلاعات تجهیزات گروه"
                        : "اطلاعات بخش‌ها"
          }
          subTitle={
            level === 1
              ? "لطفا ابتدا شماره تلفن همراه خود را وارد کنید."
              : level === 2
                ? "کد به شماره تلفن وارد شده ارسال شد."
                : level === 3
                  ? "لطفا اطلاعات خود را به دقت تکمیل کنید."
                  : level === 4
                    ? "لطفا اطلاعات گروه خود را به دقت تکمیل کنید."
                    : level === 5
                      ? "لطفا تصویر گروه را مشخص نمایید"
                      : level === 6
                        ? "لطفا تجهیزات گروه خود را وارد نمایید"
                        : "لطفا بخش‌های تجهیزات گروه خود را وارد نمایید"
          }
        >
          <GroupSignupForm level={level} setLevel={setLevel} />
        </CustomCard>
      )}

      {level === 8 && <SuccessSignup />}
    </>
  );
}

export default GroupSignup;
